import { BetQLSportItem } from "../bet-config";

const PICK_MAP: any = {
  0: "away",
  1: "home",
  2: "draw",
};

export const titleCase = (str: string) => {
  if (str && typeof str === "string") {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => {
        if (word[0]) {
          return word.replace(word[0], word[0].toUpperCase());
        }
        return word;
      })
      .join(" ");
  }
  return str;
};

export const getTotalDisplay = (value: any, showText?: boolean) => {
  if (value === "--" || value === null) {
    return "--";
  } else {
    const totalDisplay: number = parseFloat(value);
    const remainder: number = Math.abs(totalDisplay % 1);
    if (remainder === 0.25 || remainder === 0.75) {
      let temp1: number | string = totalDisplay - 0.25;
      let temp2: number | string = totalDisplay + 0.25;
      const reverse = Math.abs(temp1) > Math.abs(temp2);
      if (temp1 === 0) {
        temp1 = "PK";
      }
      if (temp2 === 0) {
        temp2 = "PK";
      }
      if (reverse) {
        if (showText) {
          return `O/U ${temp2} & ${temp1}`;
        } else {
          return `${temp2} & ${temp1}`;
        }
      } else {
        if (showText) {
          return `O/U ${temp1} & ${temp2}`;
        } else {
          return `${temp1} & ${temp2}`;
        }
      }
    } else {
      if (showText) {
        return `O/U ${totalDisplay}`;
      } else {
        return `${totalDisplay}`;
      }
    }
  }
};

export const getLineDisplay = (value: any) => {
  if (value === "--" || value === null) {
    return "--";
  } else {
    const lineDisplay = parseFloat(value);
    const remainder = Math.abs(lineDisplay % 1);
    if (remainder === 0.25 || remainder === 0.75) {
      let temp1: string | number = lineDisplay + 0.25;
      let temp2: string | number = lineDisplay - 0.25;
      const reverse = Math.abs(temp1) > Math.abs(temp2);
      if (temp1 === 0) {
        temp1 = "PK";
      }
      if (typeof temp1 === "number" && temp1 > 0) {
        temp1 = `+${temp1}`;
      }
      if (temp2 === 0) {
        temp2 = "PK";
      }
      if (typeof temp2 === "number" && temp2 > 0) {
        temp2 = `+${temp2}`;
      }
      return reverse ? `${temp2} & ${temp1}` : `${temp1} & ${temp2}`;
    } else {
      if (lineDisplay === 0) {
        return "Even";
      }
      if (lineDisplay > 0) {
        return `+${lineDisplay}`;
      }
      return `${lineDisplay}`;
    }
  }
};

export const getOurPick = (game: any, pageType: string, filterType: string, currentSportObj: BetQLSportItem) => {
  const periodFilter =
    filterType === "spread" || filterType === "moneyline" || filterType === "total" ? `FG${filterType}` : filterType;
  const { homeTeam, awayTeam } = game;
  const isNew = currentSportObj[`has${periodFilter}PowerRating`];
  const trend = game[`max${isNew ? "New" : ""}${periodFilter}Trend`];
  switch (pageType) {
    case "sharp":
      if (game[`sharp${periodFilter}IsHome`] === true) {
        return "home";
      } else if (game[`sharp${periodFilter}IsHome`] === false) {
        return "away";
      } else if (currentSportObj.hasDraws && game[`sharp${periodFilter}IsHome`] === null) {
        return "draw";
      }
      break;
    case "public":
      if (game[`sharp${periodFilter}TicketIsHome`] === true) {
        return "home";
      } else if (game[`sharp${periodFilter}TicketIsHome`] === false) {
        return "away";
      } else if (currentSportObj.hasDraws && game[`sharp${periodFilter}TicketIsHome`] === null) {
        return "draw";
      }
      break;
    case "value":
      // totals don't support using teamId from the trend, so need a special case
      if (filterType.includes("total") && isNew) {
        if (game[`value${periodFilter}PreferredTotal`]) {
          if (game[`value${periodFilter}PreferredTotal`] === "under") {
            return "home";
          } else {
            return "away";
          }
        }
      } else if (trend) {
        if (trend.teamId === homeTeam?.id) {
          return "home";
        } else if (trend.teamId === awayTeam?.id) {
          return "away";
        } else if (currentSportObj.hasDraws && trend.teamId === null) {
          return "draw";
        }
      }
      break;
    case "movement":
      break;
  }
  const period = filterType === "spread" || filterType === "moneyline" ? `FG${filterType}` : filterType;
  const awayData = game[`current${period}AwayData`];
  const homeData = game[`current${period}HomeData`];
  const drawData = game[`current${period}DrawData`];
  if (awayData !== null && homeData !== null) {
    const lines = [awayData, homeData];
    if (drawData !== null) {
      lines.push(drawData);
    }
    const pickIndex = lines.indexOf(Math.min(...lines));
    if (pickIndex >= 0) {
      return PICK_MAP[pickIndex];
    }
  }
  return "away";
};
